import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FlatButton from '../Variants/Flat';
import RaisedButton from '../Variants/Raised';
import TextButton from '../Variants/Text';
import IconButton from '../Variants/Icon';

const VariantButtonMap = {
  raised: RaisedButton,
  flat: FlatButton,
  text: TextButton,
  icon: IconButton
};

export default class ButtonWrapper extends React.Component {
  constructor(props) {
    super(props);
    const { type, cssStyles } = props;
    this.Button = VariantButtonMap[type] || VariantButtonMap.text;
    this.Button = withStyles(cssStyles)(this.Button);
  }
  render() {
    return (
      <this.Button {...this.props} />
    );
  }
}

ButtonWrapper.propTypes = {
  type: PropTypes.string,
  cssStyles: PropTypes.object,
};

ButtonWrapper.defaultProps = {
  cssStyles: {},
  type: 'text'
};



// WEBPACK FOOTER //
// ./src/widgets/Button/ButtonWrapper/ButtonWrapper.jsx